import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Observable } from 'rxjs'
import { Permissions } from 'src/app/core/enums/permissions.enum'
import { ProviderInfo } from 'src/app/obstacle/model/provider-info.model'

@Component({
  selector: 'app-rc-layer-config',
  templateUrl: './rc-layer-config.component.html',
  styleUrls: ['./rc-layer-config.component.scss'],
  standalone: false,
})
export class RcLayerConfigComponent {
  Permissions = Permissions

  @Input() isLayerSelectionVisible: boolean = false
  @Input() providerInfo$!: Observable<ProviderInfo>

  constructor() {}

  toggleLayerSwitchVisibility() {
    this.isLayerSelectionVisible = !this.isLayerSelectionVisible
  }
}
